/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TrainingRoomType {
    Undefined = 0,
    Physical = 1,
    Virtual = 2,
    DigitalSignage = 4,
    NonSimulation = 8,
}
